import React, { ReactElement } from 'react';
import { MenuProps } from 'antd';
import { Trans } from 'react-i18next';
import { ColumnsType } from 'common/components/antd/Table/Table';
import TableActionColumnDropdown from 'common/components/TableActionColumnDropdown/TableActionColumnDropdown';
import { RenderGUID } from 'domains/accounts/utils/render-account-iban';
import { EMerchantsTableColumnKey } from '../enums/merchants.enums';
import { TMerchantsTableRecord } from '../types/merchants.types';

export const getColumns = ({
  menuItems,
  onItemActionClick,
}: {
  menuItems?: MenuProps['items'];
  onItemActionClick?: any;
} = {}): ColumnsType<TMerchantsTableRecord> => [
  {
    title: <Trans i18nKey="usrRoleMng.merchants.table.column.guid" />,
    width: 330,
    dataIndex: EMerchantsTableColumnKey.GUID,
	  render: (value, record, index): ReactElement => <RenderGUID value={value} index={index} />,
  },
	{
    title: <Trans i18nKey="usrRoleMng.merchants.table.column.name" />,
    width: 330,
    dataIndex: EMerchantsTableColumnKey.Name,
  },
	{
    title: <Trans i18nKey="usrRoleMng.merchants.table.column.companyCode" />,
    width: 330,
    dataIndex: EMerchantsTableColumnKey.CompanyCode,
  },
	{
    title: <Trans i18nKey="usrRoleMng.merchants.table.column.callbackUrl" />,
    width: 330,
    dataIndex: EMerchantsTableColumnKey.CallbackUrl,
  },
	{
    title: <Trans i18nKey="usrRoleMng.merchants.table.column.email" />,
    width: 330,
    dataIndex: EMerchantsTableColumnKey.Email,
  },
  {
    title: '',
    width: 20,
    key: EMerchantsTableColumnKey.Menu,
    dataIndex: EMerchantsTableColumnKey.Menu,
    searchable: false,
    render: (status: number, record: any) => (
      <TableActionColumnDropdown
        record={record}
        onClickItemAction={onItemActionClick}
        menuItems={menuItems}
      />
    ),
  },
];
